















import Vue from "vue";
import Processing from "@/components/table/Processing.vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import BasedOnSection from "./BasedOnSection.vue";
import ResultsSection from "./ResultsSection.vue";

export default Vue.extend({
  components: {
    Modal,
    BasedOnSection,
    // Processing,
    ResultsSection,
  },

  props: ["modalData"],
  setup(props) {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "65rem",
      height: "46rem",
      withTopRightCloseBtn: true,
    };

    return {
      config,
    };
  },
});
